module.exports = __webpack_public_path__ + "static/img/protect_4.7fbe8a84.png";